import {
  IAlert,
  registerAlertTrigger,
} from "@rentiohq/shared-frontend/dist/utils/alert/alert.utils";
import { getMessageForError } from "@rentiohq/shared-frontend/dist/utils/error.utils";
import React from "react";
import { AlertManager, withAlert } from "react-alert";

interface IProps {
  children?: React.ReactNode;
  alert: AlertManager;
}

class UtilAlertProviderBase extends React.PureComponent<IProps> {
  constructor(props: IProps) {
    super(props);

    const alertTrigger = ({ message = "", error, type, onClose }: IAlert) => {
      props.alert.show(error ? getMessageForError(error) : message, {
        type,
        onClose,
      });
    };
    registerAlertTrigger(alertTrigger);
  }

  // Lifecycle methods
  public render() {
    return this.props.children;
  }
}

export const UtilAlertProvider = withAlert()(UtilAlertProviderBase);
